import { cloneDeep } from 'lodash';
import { updateCustomizedAction } from 'pages/ChartEditorPage/actions/chartEditor';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import Accordion from 'shared/Accordion';
import { fpsOptions } from 'shared/editor/PublishHelper';
import ActionWidget from 'shared/widgets/ActionWidget';
import NumberInputWidget from 'shared/widgets/NumberInputWidget';
import SelectWidget from 'shared/widgets/SelectWidget';
import api from '../../utils/ajax';

export default function PublishSection() {
  const dispatch = useDispatch();
  const chart: any = useSelector((state: RootState) => state.chartEditorPage.chart);
  const { aggregatedOptions } = useSelector((state: RootState) => state.projectConfig);
  const { constr } = useSelector((state: RootState) => state.chartEditorPage);
  const { user } = useSelector((state: RootState) => state.profile);
  const [form, setForm] = useState({
    sourceWidth: 1920,
    sourceHeight: 1080
  });
  const [loadingMovieDownload, setLoadingMovieDownload] = useState(false);
  const [fpsValue, setFpsValue] = useState<{
    value: number | string;
    label: string;
  }>({
    value: 60,
    label: '60FPS (Web/Mobile)'
  });

  useEffect(() => {
    setDefaultValues();
  }, []);

  const setDefaultValues = () => {
    const newForm = cloneDeep(form);
    const newFpsValue = cloneDeep(fpsValue);

    const state: {
      form: {
        sourceWidth: number;
        sourceHeight: number;
      };
      fpsValue: {
        value: number | string;
        label: string;
      };
    } = {
      form: newForm,
      fpsValue: newFpsValue
    };

    if (chart.exporting && chart.exporting.sourceWidth) {
      state.form.sourceWidth = chart.exporting.sourceWidth || 1920;
    }
    if (chart.exporting && chart.exporting.sourceHeight) {
      state.form.sourceHeight = chart.exporting.sourceHeight || 1080;
    }
    if (chart.everviz && chart.everviz.exporting && chart.everviz.exporting.fps) {
      state.fpsValue = fpsOptions.filter((c) => c.value === chart.everviz.exporting.fps)[0];
    }

    if (
      state.form.sourceWidth !== form.sourceWidth ||
      state.form.sourceHeight !== form.sourceHeight ||
      state.fpsValue.value !== fpsValue.value
    ) {
      setForm(state.form);
      setFpsValue(state.fpsValue);
    }
  };

  const updateCustomized = (optionProps: string, val: unknown) =>
    dispatch(updateCustomizedAction({ optionProps, val }));

  const onSelectChange = (selected: unknown) => {
    const option = selected as { value: number | string; label: string };
    updateCustomized('everviz.exporting.fps', option.value);
    setFpsValue(option);
  };

  const onInputChange = (name: 'sourceWidth' | 'sourceHeight', newValue: { val: unknown }) => {
    const value = newValue.val as number;
    const newForm = cloneDeep(form);
    newForm[name] = value;
    updateCustomized(`exporting.${name}`, value);
    setForm(newForm);
  };

  const onClickMovieDownload = () => {
    if (!user) return;

    let chartType = constr;
    const key = 'video/quicktime';
    if (chartType === 'Chart') chartType = 'chart';

    setLoadingMovieDownload(true);

    api.ajax({
      type: 'post',
      url: '/video/export',
      data: {
        options: JSON.stringify(aggregatedOptions),
        type: key,
        constr: chartType,
        projectType: 'chart',
        cssModules: JSON.stringify((window as any)?.Everviz?.externalCSS || []),
        pluginConfig: JSON.stringify({}),
        email: user.email
      }
    });

    setTimeout(() => {
      setLoadingMovieDownload(false);
    }, 10000);
  };

  return (
    <Accordion
      useInternalSelect={true}
      defaultSelection={false}
      headerText="Download video"
      smallHeaderText={true}
      selectedChildren="(Beta)"
      childrenClasses={'rounded mx-4 py-2 relative flex-col gap-2'}
    >
      <NumberInputWidget
        value={form.sourceWidth}
        label="Width (px)"
        onChange={(newValue) => onInputChange('sourceWidth', newValue)}
      />
      <NumberInputWidget
        value={form.sourceHeight}
        label="Height (px)"
        onChange={(newValue) => onInputChange('sourceHeight', newValue)}
      />

      <SelectWidget selectOptions={fpsOptions} onChange={onSelectChange} value={fpsValue} label={'FPS'} />

      <ActionWidget label={'Download'} icon={'download'} onClick={onClickMovieDownload} />

      {loadingMovieDownload && (
        <div>
          We are processing your request. <br />
          <br />
          You will receive an email shortly at {user.email} with a link to your video.
        </div>
      )}
    </Accordion>
  );
}
